/* sts-cash-sync.js: keeps the cart's Skin Type Cash figure (the gc-value
   cart attribute and the LlamaCart drawer label) in step with the cart.
   Moved out of layout/theme.liquid 2026-09-22. Notes:
   docs/new-theme-v4/asset-notes/sts-cash-sync.md */
(function () {
  'use strict';
  var script = document.currentScript;
  var countAttr = script && script.getAttribute('data-cart-count');
  /* Cart size at render (Liquid). Unknown -> treat as non-empty, the old path. */
  var renderedCount = countAttr === null || countAttr === '' ? 1 : parseInt(countAttr, 10) || 0;

  var isUpdating = false;
  var lastUpdateTime = 0;
  var delayBetweenTriggers = 2000;
  var targetVariantID = '49337457312046';
  var isInternalUpdate = false;
  var codeBlocked = false;

  async function getCartData() {
    try {
      var cartData = JSON.parse(localStorage.getItem('cartbot_data_cart'));
      if (cartData) return cartData;
      var response = await fetch('/cart.js');
      return await response.json();
    } catch (error) {
      console.error('❌ CASHBACK: Error fetching cart data:', error);
      return null;
    }
  }

  /* The one calculation: snippets/sts-cash-cents.liquid, rendered against the
     live cart. null = not known (leave everything as it is), never 0. */
  async function fetchCartCashCents() {
    try {
      var root = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
      var res = await fetch(root + '?section_id=api-cart-cash', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!res.ok) return null;
      var html = await res.text();
      var m = html.match(/data-sts-cash-cents="(\d+)"/);
      if (!m) return null;
      /* A discount code is what zeroed it (DECISIONS 2026-10-19): say so. */
      codeBlocked = /data-sts-cash-code="1"/.test(html);
      return parseInt(m[1], 10);
    } catch (error) {
      console.error('❌ CASHBACK: Error fetching cart cash total:', error);
      return null;
    }
  }

  async function updateCartItemGCValue(knownCents) {
    try {
      var cashCents = knownCents === undefined ? await fetchCartCashCents() : knownCents;
      /* #202: no $0 figure is ever written. A discount code that zeroed it
         gets the sentence instead, else the row kept the old "earns $X". */
      if (!cashCents || cashCents <= 0) {
        if (cashCents !== 0 || !codeBlocked) return;
      }

      // Wait a bit for the cart drawer to render if it is opening.
      await new Promise(function (resolve) { setTimeout(resolve, 100); });

      var cartItems = document.querySelectorAll('.lcu__drawer__item');
      if (cartItems.length === 0) return;

      cartItems.forEach(function (item) {
        var linkElement = item.querySelector('a[href*="variant"]');
        if (!linkElement) return;
        var variantMatch = linkElement.href.match(/variant=(\d+)/);
        var variantID = variantMatch ? variantMatch[1] : null;
        if (variantID !== targetVariantID) return;

        var priceElement = item.querySelector('.lcu__text--pale.lcu__text--xs.lcu__text--normal.lcu__text--leading-none');
        if (!priceElement) return;
        /* Only ever in the shop's own currency: snippets/sts-cash-cents.liquid
           returns 0 in any other market. The head's STS.money (v6.1 13.3). */
        var M = window.STS && window.STS.money;
        var newText = cashCents <= 0 ? 'No Skin Type Cash on orders with a discount code' : 'This order earns ' + (M ? M.cents(cashCents, { cur: M.shop }) : '$' + (cashCents / 100).toFixed(2)) + ' Skin Type Cash';
        /* Hook for snippets/sts-cash-affiliate-css.liquid (04-Q39). */
        priceElement.setAttribute('data-sts-cash-drawer', '');
        if (priceElement.textContent !== newText) priceElement.textContent = newText;
      });
    } catch (error) {
      console.error('❌ CASHBACK: Error updating cart item gc-value:', error);
    }
  }

  async function updateCartWithGCValue(knownCents) {
    try {
      var cart = await getCartData();
      if (!cart) return;

      var cartItems = cart.items || [];
      var hasCashbackItem = cartItems.some(function (item) {
        return item && item.id && item.id.toString() === targetVariantID;
      });

      if (window.previousCashbackState === undefined) {
        window.previousCashbackState = hasCashbackItem;
      }
      // The cashback line itself just came or went: skip one cycle (loop guard).
      if (window.previousCashbackState !== hasCashbackItem) {
        window.previousCashbackState = hasCashbackItem;
        return;
      }
      window.previousCashbackState = hasCashbackItem;

      var cashCents = knownCents === undefined ? await fetchCartCashCents() : knownCents;
      if (cashCents === null) return;

      var newGCValue = cashCents / 100;
      // Compare against the live cart: LlamaCart's cached copy has no gc-value,
      // so trusting it re-posted an unchanged value on every page.
      var live = cart;
      try { live = await (await fetch('/cart.js')).json(); } catch (e) {}
      var previousGCValue = parseFloat(((live && live.attributes) || {})['gc-value'] || '0.00');
      if (Math.abs(previousGCValue - newGCValue) < 0.01) return;

      // Our own write must not trigger another update.
      isInternalUpdate = true;
      document.removeEventListener('lcu:smart-cart:updated', handleCartUpdate);

      // Send only our key: Shopify merges attributes, and posting the whole
      // (possibly cached, stale) object wiped providerId/affiliateCode.
      var updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'gc-value': newGCValue.toFixed(2) } })
      });
      if (!updateResponse.ok) {
        console.error('❌ CASHBACK: Failed to update cart with GC value:', updateResponse.statusText);
      }

      setTimeout(function () { isInternalUpdate = false; }, 1500);
      setTimeout(function () {
        document.addEventListener('lcu:smart-cart:updated', handleCartUpdate);
      }, 1500);
    } catch (error) {
      console.error('❌ CASHBACK: Error updating cart with gc-value:', error);
      isInternalUpdate = false;
      setTimeout(function () {
        document.addEventListener('lcu:smart-cart:updated', handleCartUpdate);
      }, 1500);
    }
  }

  function handleCartUpdate() {
    if (isInternalUpdate) return;
    var currentTime = new Date().getTime();
    if (isUpdating || (currentTime - lastUpdateTime) < delayBetweenTriggers) return;
    isUpdating = true;

    setTimeout(async function () {
      try {
        /* One request, spent twice: the attribute and the drawer label. */
        var cashCents = await fetchCartCashCents();
        await updateCartWithGCValue(cashCents);
        await updateCartItemGCValue(cashCents);
      } catch (error) {
        console.error('❌ CASHBACK: Error in cart update process:', error);
      }
      isUpdating = false;
      lastUpdateTime = new Date().getTime();
    }, 500);
  }

  /* Called by assets/quiz-results.js, assets/sts-buy-again.js and
     assets/sts-routine-shared.js after they write to the cart. */
  window.updateCartWithGCValue = updateCartWithGCValue;
  window.updateCartItemGCValue = updateCartItemGCValue;

  function init() {
    if (!window.cashbackSystemInitialized) {
      document.addEventListener('lcu:smart-cart:updated', handleCartUpdate);
      window.cashbackSystemInitialized = true;
    }
    /* Empty cart at render: no /cart.js read, no section render. An empty cart
       has no cashback line, and every later change arrives through
       lcu:smart-cart:updated above. */
    if (renderedCount <= 0) {
      window.previousCashbackState = false;
      return;
    }
    getCartData().then(function (cart) {
      if (cart && cart.items) {
        window.previousCashbackState = cart.items.some(function (item) {
          return item && item.id && item.id.toString() === targetVariantID;
        });
      }
    }).catch(function (err) {
      console.error('❌ CASHBACK: Error initializing cashback state:', err);
    });
    setTimeout(handleCartUpdate, 2000);
  }

  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
